import {
  InputGroup,
  Input as ChakraInput,
  InputLeftAddon,
  Text,
} from '@chakra-ui/react'
import { forwardRef, memo } from 'react'

const Input = ({ name, label, ...rest }, ref) => {
  return (
    <>
      <InputGroup {...rest}>
        <InputLeftAddon
          children={label}
          w={rest.labelWidth}
          textTransform="uppercase"
          fontSize="14px"
          color="#1D1D1D"
          borderColor={rest.error ? '#E53E3E' : '#C5CED6'}
          p={rest.rightAddon && '2'}
        />
        <ChakraInput
          placeholder={rest.placeholder}
          name={name}
          type={rest.type}
          borderColor={rest.error ? '#E53E3E' : '#378BBF'}
          fontSize="14px"
          ref={ref}
          {...rest}
          onChange={rest.onChange}
          _disabled={{ bgColor: '#F1F1F1', cursor: 'not-allowed' }}
        />
        {rest.rightAddon && (
          <Text
            as="span"
            position="absolute"
            right="0"
            top="0"
            bottom="0"
            display="flex"
            alignItems="center"
            pr="10px"
            color="#378BBF"
            fontSize="14px"
            textTransform="uppercase"
          >
            {rest.rightAddon}
          </Text>
        )}
      </InputGroup>
      {/* {rest.error && (
        <Text display="inline-block" fontSize="12px" color="#E53E3E">
          {rest.error}
        </Text>
      )} */}
    </>
  )
}

export default memo(forwardRef(Input))
